export default "/assets/images/mila-feed-07-thumbnail.jpg?49265210d4af94172baa308ab59eb54c";